import { render } from "./SkeletonComponent.vue?vue&type=template&id=b1771d6e&ts=true"
import script from "./SkeletonComponent.vue?vue&type=script&lang=ts"
export * from "./SkeletonComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__